import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { DatePipe, NgForOf, NgIf } from '@angular/common';
import { MemberCardComponent } from './member-card/member-card.component';
import { MemberService } from './member.service';
import { SharedServiceService } from '../../services/shared-service.service';
import { Member } from '../../models/member';
import { FormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatCheckbox } from '@angular/material/checkbox';
import { ToastService } from '../../services/toast.service';
import { Router, NavigationStart } from '@angular/router';

@Component({
  selector: 'app-member-list',
  standalone: true,
  imports: [NgIf,MatCardModule, NgForOf, MemberCardComponent,
    FormsModule, MatTableModule, MatPaginatorModule,MatCheckbox, MatPaginator, RouterLink, DatePipe],
  templateUrl: './member-list.component.html',
  styleUrl: './member-list.component.css'
})
export class MemberListComponent {
  @ViewChild('nameInput') nameInput!: ElementRef;
  displayedColumns: string[] = ['No', 'FirstName', 'Email', 'Mobile', 'Team', 'CreatedDateTime', 'Actions'];
  //dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
  timeout: any = null;
  filter: any = {
    'filterType': 'none',
    'name': '',
    'email': '',
    'phone': '',
    'teamId': '',
    'fromDate': new Date(),
    'toDate': new Date(),
    'userLoggedIn': '',
    'isAssigned': '',
    'level': '0'
  };
  selectFilterBy: 'none';
  searchType: string = 'Name';
  isAdmin: any;
  role: any;
  memberLists: any = [];
  totalRecords: any = [];
  memberDetails: any = [];
  pageSize: number = 10;
  teamsFilter: any = [];
  selectedTeamsFilter: "";
  selectLevelBy: "0";
  isNavigation:any;
  teamsLoaded: boolean = false;
  isLoading: boolean = true;

  paginator: MatPaginator;
  dataSource = new MatTableDataSource<Member>;
  pageIndexVal: any = 0;
  selectedMemberIds: string[] = []; // To store selected member IDs
  isTeamAssignment: boolean = false;
  isTeamMemView: boolean = false;
  teamIdParam: string = '';
  teamName:string =''
    constructor(private router: Router,private memberService: MemberService, private route: ActivatedRoute, private toast: ToastService, private SharedService: SharedServiceService) {
    this.role = this.SharedService.getloggedUserRole();
    let user = this.SharedService.getLoggedInUser();
    this.filter.userLoggedIn = user.id

    if (this.role == 'Administrator') {
      this.isAdmin = true;
    }
    else if (this.role != 'Administrator') {
      this.isAdmin = false;
    }

  }
  ngOnInit(): void {
    this.filter.teamId = "";    
    this.route.paramMap.subscribe(params => {
      var teamId = this.route.snapshot.queryParamMap.get('teamId') || '';
      if (teamId != null && teamId != '') {
      this.teamName = this.route.snapshot.queryParamMap.get('name') || '';
      this.teamIdParam = teamId;
      var isView = this.route.snapshot.queryParamMap.get('IsTeamMemView') || false;
      this.isTeamMemView = isView == 'true';
      if (this.isTeamMemView) {
        this.filter.isAssigned = this.isTeamMemView;
      }
    }
      if (teamId) {
        this.isTeamAssignment = true;
        if (this.isTeamAssignment) {
          this.filter.teamId = teamId;
          this.displayedColumns = ['No', 'Select', 'FirstName', 'Email', 'Mobile', 'Team', 'Actions'];
        }
      }
    });
    this.selectFilterBy = 'none';
    this.selectedTeamsFilter = "";
    this.selectLevelBy = "0";
    this.getTeamsForFilter();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
       sessionStorage.setItem('navigationEvent', 'true'); 
      }
    });

    if (sessionStorage.getItem('navigationEvent')) {
      const { stateObj } = window.history.state;
      if (stateObj) {
        // apply only defined values; fall back to defaults otherwise
        this.filter = {
          ...this.filter,
          ...stateObj,
          name: stateObj.name ?? '',
          email: stateObj.email ?? '',
          phone: stateObj.phone ?? ''
        };
        this.selectFilterBy = this.filter.filterType ?? 'none';
        this.selectedTeamsFilter = this.filter.teamId ?? '';
        this.selectLevelBy = this.filter.level ?? '0';
        this.searchType = this.filter.email ? 'Email' : this.filter.phone ? 'Phone Number' : 'Name';
      } else {
        // no stateObj: ensure a fresh filter (but don't reload teams or call API since it will be called below)
        this.resetFiltersOnly();
      }
    }
  
    // this.dataSource.paginator = this.paginator;

    // let level:any=['memberLevel1','memberLevel2','memberLevel3','memberLevel4','memberLevel5'];
    // for(let i=0;i<5;i++){
    //   this.getMemberRecord(1,level[i],i);
    // }
    // Call getMemberRecord only once after all filter setup is complete
    this.getMemberRecord(0);
    setTimeout(() => {
      sessionStorage.removeItem('navigationEvent');
    }, 100);
  
  }
  ngAfterViewInit(){
 this.nameInput.nativeElement.value = this.filter.email || this.filter.phone || this.filter.name || '';
  }

  getTeamsForFilter() {
    // Prevent duplicate API calls if teams are already loaded
    if (this.teamsLoaded && this.teamsFilter.length > 0) {
      return;
    }
    this.memberService.getTeams(this.isAdmin).subscribe(data => {
      this.teamsFilter = data['result'];
      this.teamsLoaded = true;
    });
  }

  getMemberRecord(page: any) {
    this.isLoading = true;
    this.memberService.getMemberByFilterAPI(this.filter, page, this.isAdmin, this.isTeamMemView).subscribe(response => {
      this.memberDetails = response;
      this.dataSource = this.memberDetails['result'];
      this.dataSource.paginator = this.memberDetails['totalCount'];
      this.isLoading = false;

    });
  }

  getMemberRecord1(page: any, level: any, index: any) {
    let user = this.SharedService.getLoggedInUser();



    this.memberService.getMemberByLevel(user.id, page, level, this.isAdmin).subscribe(response => {

      this.memberDetails = response;
      let memberData: any = [];
      if (this.memberDetails['result'].length > 0) {
        for (let j = 0; j < this.memberDetails['result'].length; j++) {
          memberData[j] = [{
            'id': this.memberDetails['result'][j].memberId,
            'personName': this.memberDetails['result'][j].firstName + ' ' + this.memberDetails['result'][j].lastName,
            'subTitle': '',
            'age': this.memberDetails['result'][j].age,
            'email': this.memberDetails['result'][j].email,
            'phoneNumber': this.memberDetails['result'][j].mobileNo,
            'address': this.memberDetails['result'][j].address,
            'team': ''

          }];
        }
      }
      this.memberLists[index] = memberData;
      this.totalRecords[index] = this.memberDetails['totalCount'];
      // this.memberDetails =  this.memberDetails['memberTeamAssignment'];

    });

     
  }

  filterData(data: any, type: any) {
    //this.filter.teamId = '';
    //this.selectedTeamsFilter = "";
    //this.filter.level = '';

    clearTimeout(this.timeout);
    var $this = this;
    if (data.target.value != '') {
      this.timeout = setTimeout(() => {
        if (type == 1) {
          this.setSearchValue(data.target.value);
        }
        else if (type == 2) {
          this.filter.filterType = data.target.value;
        }
        else if (type == 3) {
          this.filter.teamId = data.target.value;
        }
        else if (type == 4) {
          this.filter.level = data.target.value;
        }
        this.getMemberRecord(0);
      }, 500);
    } else {
      if (type == 1) {
        this.setSearchValue('');
      }
      if (type == 3) {
        this.filter.teamId = '';
      }
      if (type == 4) {
        this.filter.level = '';
      }

      this.getMemberRecord(0);
    }
  }

  private setSearchValue(value: string) {
    this.filter.name = '';
    this.filter.email = '';
    this.filter.phone = '';
    if (this.searchType == 'Email') {
      this.filter.email = value;
    } else if (this.searchType == 'Phone Number') {
      this.filter.phone = value;
    } else {
      this.filter.name = value;
    }
  }

  onSearchTypeChange() {
    if (this.nameInput && this.nameInput.nativeElement) {
      this.nameInput.nativeElement.value = '';
    }
    this.setSearchValue('');
    this.getMemberRecord(0);
  }

  pageChangeEvent(page: any) {
     
    this.pageIndexVal = this.pageSize * page.pageIndex;
    this.getMemberRecord(page.pageIndex);
  }
  resetSearch() {
    // Reload teams when user explicitly clicks reset button (in case teams changed)
    this.getTeamsForFilter();
    this.resetFiltersOnly();
    // Call API after resetting filters when user clicks reset button
    this.getMemberRecord(0);
  }

  private resetFiltersOnly() {
    // Reset filter values only, without calling API (used during initialization)
    if (this.nameInput && this.nameInput.nativeElement) {
      this.nameInput.nativeElement.value = '';
    }
    this.filter.filterType = 'none';
    this.filter.teamId = '';
    this.filter.level = '0';
    this.filter.name = '';
    this.filter.email = '';
    this.filter.phone = '';
    this.selectFilterBy = 'none';
    this.selectedTeamsFilter = "";
    this.selectLevelBy = "0";
    this.searchType = 'Name';
  }

  toggleSelectAll(event: any): void {
    if (event.checked) {
      this.selectedMemberIds = this.memberDetails['result'].map((member: { memberId: any; }) => member.memberId);
      this.memberDetails['result'].forEach((member: { isSelected: boolean; }) => member.isSelected = true);
      this.dataSource = this.memberDetails['result'];
    } else {
      this.selectedMemberIds = [];
      this.memberDetails['result'].forEach((member: { isSelected: boolean; }) => member.isSelected = false);

    }
  }

  onMemberSelect(memberId: string, event: any): void {
    if (event.checked) {
      this.selectedMemberIds.push(memberId);
    } else {
      this.selectedMemberIds = this.selectedMemberIds.filter(id => id !== memberId);
    }
  }

  assignTeam(): void {
    let loggedInUser = this.SharedService.getLoggedInUser();   
    if (this.selectedMemberIds.length > 0) {
      let members = { memberIds: this.selectedMemberIds, teamId: this.teamIdParam, loggedInUserId: loggedInUser.id, status: '' };
      this.memberService.assignMembers(members).subscribe(response => {
        this.selectedMemberIds = [];
        this.toast.successMessage('Members assigned successfully');
        this.getMemberRecord(0);

      });
    } else {
      this.toast.errorMessage('Please choose atleast one.');
    }
  }
  unAssignTeam(): void {
    let loggedInUser = this.SharedService.getLoggedInUser();
    if (this.selectedMemberIds.length > 0) {
      let members = { memberIds: this.selectedMemberIds, loggedInUserId: loggedInUser.id, status: '' };
      this.memberService.unAssignMembers(members).subscribe(response => {
        this.selectedMemberIds = [];
        this.toast.successMessage('Members un-assigned successfully');
        this.getMemberRecord(0);

      });
    } else {
      this.toast.errorMessage('Please choose atleast one.');
    }
  }
}
